import moment from "moment";

/**
 * CALENDAR DATES (2026-10-09). Service, schedule and end dates have no
 * time of day, but they are stored as a timestamp near UTC midnight
 * (00:00Z-05:00Z depending on which screen saved them). Formatting them in
 * the browser's time zone moves the 00:00Z ones to the evening before, so
 * an Oct 10 job read "Oct 9". Read the UTC calendar date instead; that is
 * the day that was picked for every stored variant.
 */
export const dateOnly = (value: string | Date | null | undefined): moment.Moment | null =>
  value ? moment(moment.utc(value).format("YYYY-MM-DD"), "YYYY-MM-DD") : null;

export const formatDateOnly = (value: string | Date | null | undefined, fmt = "MMM D, YYYY"): string =>
  value ? moment.utc(value).format(fmt) : "";
